import { render, staticRenderFns } from "./manageUniversityExamQuestionsCopyQuestion.vue?vue&type=template&id=fa3f49b4"
import script from "./manageUniversityExamQuestionsCopyQuestion.vue?vue&type=script&lang=js"
export * from "./manageUniversityExamQuestionsCopyQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports